<template>
  <div v-if="visible" class="whitelist-modal-overlay" @click="closeModal">
    <div class="whitelist-modal" @click.stop>
      <div class="modal-header">
        <h3>白名单管理</h3>
        <button class="close-btn" @click="closeModal">
          <i class="el-icon-close"></i>
        </button>
      </div>
      <div class="modal-content">
        <div class="whitelist-content">
          <div class="whitelist-section">

            <div class="whitelist-list">
              <!-- 空状态 -->
              <div v-if="whitelistUsers.length === 0" class="empty-whitelist">
                <i class="el-icon-info"></i>
                <p>暂无白名单用户</p>
                <button class="btn btn-primary add-whitelist-btn" @click="addToWhitelist">
                  <span class="el-icon-plus"></span>
                  添加用户到白名单
                </button>
              </div>

              <!-- 用户列表 -->
              <div v-else class="whitelist-users">
                <div class="whitelist-header">
                  <div class="header-left">
                    <h5>白名单用户 ({{ whitelistUsers.length }})</h5>
                    <div class="selection-info">
                      已选择 {{ selectedWhitelistUsers.length }} 个用户
                    </div>
                  </div>
                  <div class="header-actions">
                    <div class="bulk-actions">
                      <button class="btn btn-danger" :class="{ 'disabled': selectedWhitelistUsers.length === 0 }"
                        :disabled="selectedWhitelistUsers.length === 0" @click="removeSelectedUsers" title="删除选中用户">
                        <i class="el-icon-delete"></i>
                        删除选中 ({{ selectedWhitelistUsers.length }})
                      </button>
                      <button class="btn btn-secondary" @click="selectAllWhitelistUsers" title="全选用户">
                        <i class="el-icon-check"></i>
                        全选
                      </button>
                      <button class="btn btn-link" :class="{ 'disabled': selectedWhitelistUsers.length === 0 }"
                        :disabled="selectedWhitelistUsers.length === 0" @click="clearWhitelistSelection">
                        取消选择
                      </button>
                    </div>
                    <button class="btn btn-primary add-whitelist-btn" @click="addToWhitelist">
                      <i class="el-icon-plus"></i>
                      添加更多用户
                    </button>
                  </div>
                </div>
                <div class="whitelist-grid-container">
                  <div class="whitelist-grid">
                    <div v-for="(user, index) in whitelistUsers" :key="index" class="whitelist-user-card"
                      :class="{ 'selected': selectedWhitelistUsers.includes(user.userId) }"
                      @click="toggleWhitelistUserSelection(user.userId)">
                      <div class="selection-indicator">
                        <i v-if="selectedWhitelistUsers.includes(user.userId)" class="el-icon-check"></i>
                      </div>
                      <div class="user-avatar">
                        <img v-if="user.avatar" :src="user.avatar" :alt="user.nickname || user.username" />
                        <div v-else class="default-avatar">
                          <i class="el-icon-user"></i>
                        </div>
                      </div>
                      <div class="user-info">
                        <div class="user-name">{{ user.nickname || user.username || '未知用户' }}</div>
                        <div class="user-id">ID: {{ user.userId || '未知' }}</div>
                      </div>
                      <div class="user-actions">
                        <button class="remove-btn" @click.stop="removeFromWhitelist(index)" title="从白名单移除">
                          <i class="el-icon-delete"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 用户选择弹窗 -->
    <UserSelectModal :visible="showUserSelectModal" title="选择用户添加到白名单" confirm-text="确认添加"
      :exclude-user-ids="whitelistUserIds" @close="closeUserSelectModal" @confirm="confirmUserSelection" />
  </div>
</template>

<script>
import { getWhiteList, addWhiteList, deleteWhiteList } from '@/api/talkytimes/masSending'
import UserSelectModal from '@/components/UserSelectModal.vue'

export default {
  name: 'WhitelistModal',
  components: {
    UserSelectModal
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    selectedUser: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      whitelistUsers: [],
      showUserSelectModal: false,
      selectedWhitelistUsers: [] // 选中的白名单用户ID数组
    }
  },
  computed: {
    // 获取白名单用户ID列表，用于排除已存在的用户
    whitelistUserIds() {
      return this.whitelistUsers.map(user => user.id || user.userId).filter(Boolean)
    }
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.getMassWhiteList();
      }
    }
  },
  methods: {
    // 获取群发白名单
    async getMassWhiteList() {
      try {
        console.log('selectedUser', this.selectedUser);
        const res = await getWhiteList(this.selectedUser.id);
        console.log('白名单列表响应:', res);

        if (res && res.code === 200) {
          // 处理返回的白名单用户数据
          const whitelistData = res.data || [];

          // 将API返回的数据转换为组件需要的格式
          this.whitelistUsers = whitelistData.map(user => ({
            id: user.id || user.blackUserId,
            userId: user.blackUserId,
            nickname: user.blackUserName || user.nickname || '未知用户',
            username: user.blackUserName || user.username || '未知用户',
            avatar: user.blackUserAvatarUrl || user.avatar || null
          }));

          console.log('处理后的白名单用户列表:', this.whitelistUsers);
        } else {
          console.error('获取白名单用户列表失败:', res);
          this.$message.error(res?.msg || '获取白名单用户列表失败');
        }
      } catch (error) {
        console.error('获取白名单用户列表异常:', error);
        this.$message.error('获取白名单用户列表失败');
      }
    },

    // 关闭弹窗
    closeModal() {
      this.$emit('close');
    },

    // 添加用户到白名单
    addToWhitelist() {
      this.showUserSelectModal = true;
    },

    // 从白名单移除用户
    async removeFromWhitelist(index) {
      try {
        const userToRemove = this.whitelistUsers[index];

        if (!userToRemove || !userToRemove.id) {
          this.$message.error('用户信息不完整，无法移除');
          return;
        }

        await this.$confirm('确定要从白名单中移除该用户吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        });

        console.log('移除白名单用户:', userToRemove);

        // 调用API删除白名单用户
        const response = await deleteWhiteList(this.selectedUser.id,userToRemove.userId);

        console.log('删除白名单用户响应:', response);

        if (response && response.code === 200) {
          // 从本地列表中移除用户
          this.whitelistUsers.splice(index, 1);
          this.$message.success('用户已从白名单移除');
        } else {
          console.error('删除白名单用户失败:', response);
          this.$message.error(response?.msg || '删除白名单用户失败');
        }
      } catch (error) {
        if (error === 'cancel') {
          // 用户取消操作，不需要处理
          return;
        }
        console.error('移除白名单用户异常:', error);
        this.$message.error('移除白名单用户失败');
      }
    },



    // 关闭用户选择弹窗
    closeUserSelectModal() {
      this.showUserSelectModal = false;
    },

    // 确认用户选择
    async confirmUserSelection(selectedUsers) {
      if (selectedUsers.length === 0) {
        this.$message.warning('请先选择用户');
        return;
      }

      try {
        // 获取当前用户ID
        const currentUserId = this.selectedUser.id;

        if (!currentUserId) {
          this.$message.error('无法获取当前用户信息');
          return;
        }

        // 批量添加到白名单
        const addPromises = selectedUsers.map(async (selectedUser) => {
          const userData = {
            idUser: currentUserId,
            blackUserName: selectedUser.nickname || selectedUser.username,
            blackUserId: selectedUser.id,
            blackUserAvatarUrl: selectedUser.avatar || ''
          };

          console.log('添加白名单用户数据:', userData);

          const response = await addWhiteList(userData);

          if (response && response.code === 200) {
            return { success: true, user: selectedUser };
          } else {
            console.error('添加白名单用户失败:', response);
            return { success: false, user: selectedUser, error: response?.msg };
          }
        });

        const results = await Promise.all(addPromises);
        const successCount = results.filter(result => result.success).length;
        const failedCount = results.filter(result => !result.success).length;

        if (successCount > 0) {
          // 将成功添加的用户添加到本地列表
          results.filter(result => result.success).forEach(result => {
            this.whitelistUsers.push(result.user);
          });

          this.$message.success(`成功添加 ${successCount} 个用户到白名单`);

          if (failedCount > 0) {
            this.$message.warning(`${failedCount} 个用户添加失败`);
          }
        } else {
          this.$message.error('所有用户添加失败');
        }

        this.closeUserSelectModal();
      } catch (error) {
        console.error('添加白名单用户异常:', error);
        this.$message.error('添加白名单用户失败');
      }
    },

    // 切换白名单用户选择状态
    toggleWhitelistUserSelection(userId) {
      const index = this.selectedWhitelistUsers.indexOf(userId);
      if (index > -1) {
        // 如果已选中，则取消选中
        this.selectedWhitelistUsers.splice(index, 1);
      } else {
        // 如果未选中，则添加到选中列表
        this.selectedWhitelistUsers.push(userId);
      }
    },

    // 清空白名单用户选择
    clearWhitelistSelection() {
      this.selectedWhitelistUsers = [];
    },

    // 全选白名单用户
    selectAllWhitelistUsers() {
      this.selectedWhitelistUsers = this.whitelistUsers.map(user => user.userId);
    },

    // 批量删除选中的白名单用户
    async removeSelectedUsers() {
      if (this.selectedWhitelistUsers.length === 0) {
        this.$message.warning('请先选择要删除的用户');
        return;
      }

      try {
        await this.$confirm(`确定要删除选中的 ${this.selectedWhitelistUsers.length} 个用户吗？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        });

        console.log('批量删除白名单用户:', this.selectedWhitelistUsers);

        // 调用API删除白名单用户（支持逗号拼接的ID）
        const userIds = this.selectedWhitelistUsers.join(',');
        const response = await deleteWhiteList(this.selectedUser.id,userIds);

        console.log('批量删除白名单用户响应:', response);

        if (response && response.code === 200) {
          // 从本地列表中移除选中的用户
          this.whitelistUsers = this.whitelistUsers.filter(user =>
            !this.selectedWhitelistUsers.includes(user.userId)
          );

          const deletedCount = this.selectedWhitelistUsers.length;
          // 清空选择
          this.selectedWhitelistUsers = [];

          this.$message.success(`已删除 ${deletedCount} 个用户`);
        } else {
          console.error('批量删除白名单用户失败:', response);
          this.$message.error(response?.msg || '批量删除白名单用户失败');
        }
      } catch (error) {
        if (error === 'cancel') {
          // 用户取消操作，不需要处理
          return;
        }
        console.error('批量删除白名单用户异常:', error);
        this.$message.error('批量删除白名单用户失败');
      }
    }
  }
}
</script>

<style scoped>
/* 白名单弹窗样式 */
.whitelist-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  backdrop-filter: blur(5px);
}

.whitelist-modal {
  background: white;
  border-radius: 12px;
  width: 95%;
  max-width: 1000px;
  max-height: 85vh;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  animation: modalSlideIn 0.3s ease-out;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid rgba(229, 231, 235, 0.8);
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
}

.modal-header h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  color: #1f2937;
  background: linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.close-btn {
  width: 32px;
  height: 32px;
  border: none;
  background: rgba(107, 114, 128, 0.1);
  color: #6b7280;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

.close-btn:hover {
  background: rgba(107, 114, 128, 0.2);
  color: #374151;
  transform: scale(1.1);
}

.modal-content {
  overflow: hidden;
}

.whitelist-content {
  padding: 24px;
  overflow-y: auto;
}

.whitelist-section {
  margin-bottom: 24px;
}


.whitelist-list {
  background: rgba(248, 250, 252, 0.8);
  border-radius: 8px;
  padding: 24px;
  border: 1px solid rgba(229, 231, 235, 0.8);
}

.empty-whitelist {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  color: #9ca3af;
  text-align: center;
}

.empty-whitelist i {
  font-size: 48px;
  margin-bottom: 16px;
  opacity: 0.5;
}

.empty-whitelist p {
  font-size: 16px;
  font-weight: 500;
  margin: 0 0 20px 0;
  color: #6b7280;
}

.add-whitelist-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 24px;
  background: linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(139, 92, 246, 0.3);
}

.add-whitelist-btn:hover {
  background: linear-gradient(135deg, #7c3aed 0%, #6d28d9 100%);
  box-shadow: 0 6px 20px rgba(139, 92, 246, 0.4);
  transform: translateY(-1px);
}

.add-whitelist-btn i {
  font-size: 16px;
}

/* 白名单用户列表样式 */
.whitelist-users {
  width: 100%;
}

.whitelist-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 12px;
  border-bottom: 2px solid rgba(139, 92, 246, 0.1);
}

.header-left {
  display: flex;
  align-items: center;
  gap: 16px;
}

.whitelist-header h5 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #1f2937;
}

.selection-info {
  font-size: 14px;
  color: #8b5cf6;
  font-weight: 500;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

.bulk-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.bulk-actions .btn-danger {
  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 6px;
}

.bulk-actions .btn-danger:hover:not(.disabled) {
  background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%);
  transform: translateY(-1px);
}

.bulk-actions .btn-danger.disabled {
  background: rgba(107, 114, 128, 0.3);
  color: rgba(255, 255, 255, 0.5);
  cursor: not-allowed;
  transform: none;
}

.bulk-actions .btn-secondary {
  background: linear-gradient(135deg, #6b7280 0%, #4b5563 100%);
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 6px;
}

.bulk-actions .btn-secondary:hover {
  background: linear-gradient(135deg, #4b5563 0%, #374151 100%);
  transform: translateY(-1px);
}

.bulk-actions .btn-link {
  background: none;
  border: none;
  color: #6b7280;
  font-size: 14px;
  cursor: pointer;
  padding: 8px 12px;
  border-radius: 6px;
  transition: all 0.3s ease;
}

.bulk-actions .btn-link:hover:not(.disabled) {
  background: rgba(107, 114, 128, 0.1);
  color: #374151;
}

.bulk-actions .btn-link.disabled {
  color: rgba(107, 114, 128, 0.3);
  cursor: not-allowed;
}

/* 白名单用户网格布局 */
.whitelist-grid-container {
  max-height: 400px;
  overflow-y: auto;
}

.whitelist-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  gap: 16px;
  padding: 4px;
}

.whitelist-user-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 16px;
  border-radius: 12px;
  background: white;
  border: 2px solid rgba(229, 231, 235, 0.8);
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
}

.whitelist-user-card:hover {
  border-color: rgba(139, 92, 246, 0.3);
  box-shadow: 0 4px 12px rgba(139, 92, 246, 0.1);
  transform: translateY(-2px);
}

.whitelist-user-card.selected {
  border-color: #8b5cf6;
  background: rgba(139, 92, 246, 0.05);
  box-shadow: 0 4px 12px rgba(139, 92, 246, 0.2);
}

.whitelist-user-card .selection-indicator {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 24px;
  height: 24px;
  background: #8b5cf6;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 12px;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.whitelist-user-card.selected .selection-indicator {
  opacity: 1;
}

.whitelist-user-card .user-avatar {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  overflow: hidden;
  margin-bottom: 12px;
  border: 3px solid rgba(229, 231, 235, 0.8);
  background: #f8fafc;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

.whitelist-user-card.selected .user-avatar {
  border-color: #8b5cf6;
  transform: scale(1.05);
}

.whitelist-user-card .user-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.whitelist-user-card .default-avatar {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%);
  color: white;
}

.whitelist-user-card .default-avatar i {
  font-size: 28px;
}

.whitelist-user-card .user-info {
  text-align: center;
  margin-bottom: 12px;
}

.whitelist-user-card .user-name {
  font-weight: 600;
  font-size: 14px;
  color: #1f2937;
  margin-bottom: 4px;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.whitelist-user-card .user-id {
  font-size: 12px;
  color: #6b7280;
  font-weight: 500;
}

.whitelist-user-card .user-actions {
  display: flex;
  align-items: center;
  justify-content: center;
}

.whitelist-user-card .remove-btn {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: none;
  background: rgba(239, 68, 68, 0.1);
  color: #ef4444;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

.whitelist-user-card .remove-btn:hover {
  background: rgba(239, 68, 68, 0.2);
  transform: scale(1.1);
}

.whitelist-user-card .remove-btn i {
  font-size: 14px;
}

@keyframes modalSlideIn {
  from {
    opacity: 0;
    transform: translateY(-20px) scale(0.95);
  }

  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
</style>
